import { Component, Optional } from '@angular/core';
import { ChooseFromNormativeDbService } from '@app/services';
import { SaveItemViewService } from '@app/shared/services/save-item-view.service';
import { DynamicFormService } from '@ntap/common';
import {
  BackendUploadService,
  BusinessItem,
  Item,
  ItemActionResult,
  ItemProvider,
  ItemView,
  ItemViewProviderDirective,
  NotificationService,
  ViewWindow
} from '@ntap/core';
import { map, Observable, tap } from 'rxjs';
import { SaveCloseArhivPosjednikActionComponent } from './save-close-arhiv-posjednik-action';

@Component({
  selector: 'app-save-close-arhiv-posjednik',
  templateUrl: '../../shared/components/actions/common-action-template.html'
})
export class PublishCloseArhivPosjednikActionComponent extends SaveCloseArhivPosjednikActionComponent {
  constructor(
    @Optional() protected override window: ViewWindow,
    protected override itemProvider: ItemProvider,
    protected override itemViewProvider: ItemViewProviderDirective<ItemView>,
    protected override formService: DynamicFormService,
    protected override notificationService: NotificationService,
    protected override backendUploadService: BackendUploadService,
    protected override chooseFromNormativeDbService: ChooseFromNormativeDbService,
    protected override saveItemViewService: SaveItemViewService
  ) {
    super(
      window,
      itemProvider,
      itemViewProvider,
      formService,
      notificationService,
      backendUploadService,
      chooseFromNormativeDbService,
      saveItemViewService
    );
  }

  protected override doExecuteWithItem(
    item: Item
  ): Observable<ItemActionResult> {
    const saveItem = new BusinessItem(item);
    return this.itemViewProvider.executeAction(this.action.name, saveItem).pipe(
      map((result) => new ItemActionResult(result, saveItem.data)),
      tap((itemActionResult) => {
        const resultItem = Object.assign(
          {},
          itemActionResult.item,
          itemActionResult.result
        );
        this.doUploadFile(resultItem);
      })
    );
  }
}
